import React, { useState } from 'react'
import LoadingIntro from './Components/Loading/LoadingIntro';
import App from './App';
import AllCategoryHook from './hook/category/all-category-page-hook';
import ViewHomeProductsHook from './hook/products/view-home-products-hook';
import { useEffect } from 'react';

const Main = () => {
    const [loaded, setLoaded] = useState(false);
    const [category, , ,] = AllCategoryHook();
    // const [brand, , ,] = AllBrandHook();
    const [items] = ViewHomeProductsHook()

    useEffect(() => {
        if (category
            // && brand && items
        ) {
            if (
                // brand.data && 
                category.data
                && items.length > 1
            ) {
                setTimeout(() => {
                    setLoaded(true)
                }, 1000);
            }
        }
    }, [
        // brand,
        category
        , items
    ])

    return (
        <>
            {loaded ?
                <App /> :
                <LoadingIntro />
            }
        </>
    )
}

export default Main